var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocketWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5897 12.5259C1.39742 13.5274 1 16.5002 1 16.5002C1 16.5002 3.97273 16.1028 4.97424 14.9105C5.53859 14.2428 5.53064 13.2175 4.90271 12.5975C4.59375 12.3026 4.18678 12.1322 3.75989 12.119C3.33301 12.1058 2.91628 12.2507 2.5897 12.5259V12.5259Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55098 11.3332L6.16644 8.94868C6.58941 7.85134 7.12201 6.79946 7.75613 5.80903C8.68228 4.32822 9.97187 3.10897 11.5023 2.26726C13.0326 1.42555 14.7529 0.989364 16.4995 1.0002C16.4995 3.16219 15.8795 6.96156 11.7304 9.74353C10.7264 10.3784 9.66126 10.911 8.55098 11.3332V11.3332Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1666 8.94862H2.19236C2.19236 8.94862 2.62953 6.54023 3.78206 5.76922C5.06971 4.91079 7.7563 5.76922 7.7563 5.76922",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55116 11.3329V15.3071C8.55116 15.3071 10.9595 14.8699 11.7306 13.7174C12.589 12.4298 11.7306 9.74316 11.7306 9.74316",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketWhite);
export default __webpack_public_path__ + "static/media/rocket-white.4be65e1b701d1b6a6c8d1f65c811d8d2.svg";
export { ForwardRef as ReactComponent };